import apiUrl from '../../../constants';
import axios from 'axios';
//import Paginate from 'vuejs-paginate';
import CryptoJS from 'crypto-js';
import {
	Validator
} from 'vee-validate'
import Loader from './../shared/loader'
import DatePicker from 'vue2-datepicker'
import moment from 'moment'
import download from 'downloadjs';
import {
	BasicSelect
} from 'vue-search-select'
import 'vue-search-select/dist/VueSearchSelect.css'



export default {
	name: 'ReturnInscan',
	components: {
		BasicSelect,
		Loader,

	},
	data: function() {
		return {
			isLoading: false,
			useremail: '',
			showSelectWarehouse: false,
			isLoading: false,
			showSelectClient: false,
			searchFlag: false,
			listWarehouseData: [],
			listClientData: [],
			listCourierData: [],
			listOrderData: [],
			listshipmentData: [],
			warehouse: '',
			WarehouseErr: '',
			MerchantErr: '',
			warehouseid: '',
			user_type: '',
			client: '',
			clientid: '',
			ClientErr: '',
			awbno: '',
			input: {},
			errormsg: '',
			awbentered: false,
			processFlag: '',
			shippingcompany: '',
			listCourierDataRTO: [],
			orderid: '',
			shippingid: '',
			shippingData: [],
			shippingDataInscan: [],
			errormsgCourier: '',
			errormsgClient: false,
			errormsgWarehouse: false,
			tabIndex: 0,
			listCourierWiseData: []
		}
	},


	mounted() {
		var today = new Date();
		this.formattedDate = moment(today).format('DD/MM/YYYY HH:mm:ss')
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.useremail = userdetail.email;
		var loginuseremail = userdetail.email;
		this.warehouseid = userdetail.warehouseid;
		this.clientid = userdetail.clientid;
		this.loginClientUserId = userdetail.clientid;
		this.loginuserid = userdetail.userid;
		this.userid = userdetail.userid;
		this.user_type = userdetail.utype;
		this.reportname = "ReturnInscan"
		this.reportname = this.reportname + moment().format('DD-MM-YY_HH-mm-ss') + '.xls';

		this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
		this.getcourierList();
		this.$root.$on('localStorageChanged', (newValue) => {
			// Update your local data
			this.warehouse = newValue;
			// console.log(newValue+"===============in event")
			// Perform any other actions needed
			this.getCourierListCourierWise();
		  });
		switch (this.user_type) {
			case 'system_user':

				this.showSelectWarehouse = true;
				this.showSelectClient = true;
				this.showSelectMerchant = true;
				// this.getClientList();
				// this.getWarehouseList();
				break;

			case 'client_user':
				this.clientid = userdetail.clientid;
				this.client = this.clientid;
				// this.getWarehouseList();
				this.showSelectWarehouse = true;
				break;

			case 'warehouse_user':
				this.loginUserEmail = userdetail.email;
				this.warehouse = userdetail.warehouseid;
				this.warehouseid = userdetail.warehouseid;
				this.showSelectClient = true;
				this.showSelectWarehouse = false;
				// this.getClientList();
				break;

			default:
				this.$alertify.error("Unauthorised user, Please contact your system admin");
				break
		}
	},
	methods: {
		dateFormat(date) {
			if (!date) return '';
			return moment(date).format('DD-MM-YYYY HH:mm:ss');
		},

		// getClientList() {
		// 	if (window.localStorage.getItem("clientList") !== null) {
		// 		var clientListEncrypt = window.localStorage.getItem('clientList');
		// 		var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
		// 		var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
		// 		this.listClientData = JSON.parse(plaintextclient);
		// 	} else {
		// 		var userToken = window.localStorage.getItem('userToken');
		// 		var myStr = userToken.replace(/"/g, '');
		// 		this.pageno = this.totalPage = 0;

		// 		if (this.warehouseid)
		// 			this.input = ({
		// 				warehouseid: this.warehouseid,
		// 			});
		// 		else {
		// 			this.input = {};
		// 		}
		// 		axios({
		// 				method: 'POST',
		// 				'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
		// 				'data': this.input,
		// 				headers: {
		// 					'Authorization': 'Bearer ' + myStr,
		// 				}
		// 			})
		// 			.then(result => {
		// 				this.listClientData = result.data.data;

		// 			}, error => {
		// 				console.error(error);
		// 			});
		// 	}
		// },

		getcourierList() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');

			this.input = ({});

			axios({
					method: 'GET',
					'url': apiUrl.api_url + 'courierlistRTO',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					this.listCourierData = result.data.rows;
				}, error => {
					console.error(error)
				})
		},

		// // warehouseSelected() {
		// // 	this.warehouseid = this.warehouse;
		// // 	this.errormsgWarehouse = false;
		// // 	if (this.warehouseid) {
		// // 		if (this.clientid) {
		// // 			//this.getOrderList();
		// // 		} else {
		// // 			this.getClientList();
		// // 		}
		// // 	}
		// // 	if(this.warehouseid && this.clientid && this.tabIndex == 1){
		// // 		this.getCourierListCourierWise();
		// // 	}
		// // },
		// // getWarehouseList() {
		// // 	this.listWarehouseData = [];
		// // 	this.$validator.reset();
		// // 	var userToken = window.localStorage.getItem('userToken')
		// // 	var myStr = userToken.replace(/"/g, '');
		// // 	this.pageno = 0;
		// // 	this.input = ({
		// // 		'clientid': this.client,
		// // 	});
		// // 	axios({
		// // 			method: 'POST',
		// // 			'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
		// // 			'data': this.input,
		// // 			headers: {
		// // 				'Authorization': 'Bearer ' + myStr
		// // 			}
		// // 		})
		// // 		.then(result => {
		// // 			this.listWarehouseData = result.data.data;
		// // 		}, error => {
		// // 			console.error(error)
		// // 		})
		// // },


		// // clientSelected() {
		// // 	if (this.client) {
		// // 		this.clientid = this.client;
		// // 		this.errormsgClient = false;
		// // 		if (this.user_type != 'warehouse_user') {
		// // 			this.listWarehouseData = []
		// // 			this.getWarehouseList();

		// // 			this.item = {}
		// // 			if (this.listWarehouseData.find(entry => entry.warehouseid === this.warehouse)) {
		// // 				this.warehouse = this.warehouseid = '';
		// // 			} else {
		// // 				this.warehouse = ''
		// // 			}
		// // 		} else {
		// // 			if (this.warehouseid && this.clientid);
		// // 			//this.getMerchantList();
		// // 			// this.getPOPutawayReportData();
		// // 			if(this.warehouseid && this.clientid && this.tabIndex == 1){
		// // 				this.getCourierListCourierWise();
		// // 			}
		// // 		}
		// // 	}

		// 	this.listOrderData = [];
		// },

		validateAWB() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			//alert(this.warehouseid);
			if (localStorage.getItem("selectedClient") == 'undefined') {
                this.WarehouseErr = this.$t('common.clientError');
                this.$alertify.error(this.$t('common.clientError'))
                return false;
              }
              if (localStorage.getItem("selectedWarehouse") == 'undefined') {
                this.WarehouseErr = this.$t('common.warehouseError');
                this.$alertify.error(this.$t('common.warehouseError'))
                return false;
              }
			if (this.awbno == "") {
				this.errormsg = this.$t('packingb2b.b2bPacking.modal.awbNoError');
				return false;
			} else {
				this.isLoading = true;
				this.errormsg = "";
				this.awbentered = true;
				this.input = ({
					warehouseid: localStorage.getItem("selectedWarehouse"),
					clientid: this.client,
					awbno: this.awbno,
				});
				axios({
						method: 'POST',
						'url': apiUrl.api_url + 'validateReturnsAWB',
						'data': this.input,
						headers: {
							'Authorization': 'Bearer ' + myStr,
						}
					})
					.then(result => {
						this.isLoading = false;
						if (result.data.errorCode == 0) {
							//Case For RTO
							this.processFlag = 'rto';
							this.listCourierDataRTO = result.data.data.courierlist;
							this.listshipmentData = result.data.data.shippingid;
							this.listOrderData = result.data.data.orderid;
							var indx = this.listCourierDataRTO.indexOf(this.shippingcompany);
							if (this.listCourierDataRTO.length == 1) {
								this.shippingcompany = this.listCourierDataRTO[0];
								this.orderid = this.listOrderData[0];
								this.shippingid = this.listshipmentData[0];
							} else {
								this.orderid = this.listOrderData[indx];
								this.shippingid = this.listshipmentData[indx];
							}


							this.getorderAssociatedAWB(this.shippingid);
						} else if (result.data.errorCode == -1) {
							// Case For SR
							this.processFlag = 'sr';
							this.listCourierData=result.data.data.courierlist?result.data.data.courierlist:this.listCourierData
							// this.$alertify.error(result.data.msg);
							this.$alertify.error(this.$t(`apiErrors.${result.data.errorLabel}`) );
						} else {
							this.$alertify.error(result.data.msg);
						}
					}, error => {
						console.error(error);
					});
			}

		},

		getCourierListCourierWise(){
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			if (localStorage.getItem("selectedWarehouse") == 'undefined' || localStorage.getItem("selectedWarehouse")=='') {
				this.$alertify.error(this.$t('common.warehouseError'))
				this.WarehouseErr = this.$t('common.warehouseError');
				return false;
			}
			if (localStorage.getItem("selectedClient") == 'undefined') {
				this.$alertify.error(this.$t('common.clientError'))
				this.WarehouseErr = this.$t('common.warehouseError');
				return false;
			}
			this.input = ({
				warehouseid: localStorage.getItem("selectedWarehouse"),
				clientid: this.client,
			});

			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'courierMasterList',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					this.listCourierWiseData = result.data.data.rows;
				}, error => {
					console.error(error)
				})
		},

		getorderAssociatedAWB(shippingid) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				shippingid: this.shippingid,
				clientid: this.client,
			});

			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getorderAssociatedAWB',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					if (result.data.errorCode == 0) {
						var awblist = result.data.data;
						var awblist = result.data.data
						for (var i = 0; i < result.data.count; i++) {
							if (awblist[i].shipmentstatus == 'dispatched') {
								this.shippingData.push({
									awbnumber: awblist[i].awbno,
									couriername: awblist[i].shippingcompany,
									shippingid: awblist[i].shippingid,
								});
								if (i == 0 || awblist[i - 1].awbno != awblist[i].awbno) {
									this.shippingDataInscan.push({
										orderid: this.orderid,
										awbno: awblist[i].awbno,
										clientid: this.clientid,
										warehouseid: this.warehouseid,
										transporter: awblist[i].shippingcompany,
										customerfirstname: awblist[i].customerfirstname,
										customerlastname: awblist[i].customerlastname,
										useremail: this.useremail
									});
								}

							} else if (awblist[i].shipmentstatus == 'rto') {
								this.$alertify.error("RTO Has Already Been Marked For This Order");
								return false;
							} else {
								invalidFlag = false;
								break;
							}
						}
					}
				}, error => {
					console.error(error);
				});
		},

		saveMarkRto() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.isLoading = true;

			if (this.shippingcompany == "") {
				var courierCompany = this.shippingData[0].couriername;
			} else {
				var courierCompany = this.shippingcompany;
			}


			var i = 0;
			var allorders = '';
			this.input = ({
				useremail: this.useremail,
				clientid: this.client,
				orderid: this.orderid,
				shippingid: this.shippingid,
				warehouseid: localStorage.getItem("selectedWarehouse"),
				shippingcompany: this.shippingcompany,
				merchantid: this.merchantid != null ? this.merchantid : 0,
				processname : 'rto',
				awbno : this.awbno,
			})

			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'saveSRRTOInscan',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(async result => {
					var response = result.data.errorCode
					if (response == 0) {
						this.isLoading = false;
						this.$alertify.success(result.data.msg);
						this.resetForm();

					} else {
						this.$alertify.error(result.data.msg);
					}
				}, error => {
					console.error(error)
				})
		},

    // Function Currently Not IN Use
		getDataInscanRto() {

			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			var self = this;
			this.shippingDataInscan.forEach(function(item) {
				// Now looping here to get the information
				var inputData = ({
					awbno: item.awbno,
					warehouseid: localStorage.getItem("selectedWarehouse"),
					couriername: item.transporter,
				});

				axios({
						method: 'POST',
						'url': apiUrl.api_url + 'checkawbnoReturn',
						'data': inputData,
						headers: {
							'Authorization': 'Bearer ' + myStr
						}
					})
					.then(async (awbData) => {
						//console.log(awbData);return false;
						var awbData = awbData.data;
						var shippingid = {};
						shippingid = awbData.data.shippingid;
						var sku = awbData.data.sku;
						var totalquantity = awbData.data.totalquantity;
						// await this.saveInscanRTO(item.awbno, item.transporter, shippingid, sku, totalquantity, item.customerfirstname, item.customerlastname, item.warehouseid, item.clientid);
						var inputData = ({
							orderid: item.orderid,
							awbno: item.awbno,
							customerfirstname: item.customerfirstname,
							customerlastname: item.customerlastname,
							transporter: item.transporter,
							createdby: item.useremail,
							createddatetime: self.dateFormat(new Date()),
							warehouseid: localStorage.getItem("selectedWarehouse"),
							boxcondition: 'Good',
							sku: sku,
							quantity: totalquantity,
							shippingid: shippingid,
							clientid: localStorage.getItem("selectedClient"),
							merchantid: self.merchantid != null ? self.merchantid : 0,
						});

						axios({
								method: 'POST',
								'url': apiUrl.api_url + 'SaveRTO',
								'data': inputData,
								headers: {
									'Authorization': 'Bearer ' + myStr
								}
							})
							.then(result => {
								// success
								return true;
							})

					})

			})

			return true;

		},
    // Function Currently Not IN Use
		saveInscanSR() {

			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');

			if (this.shippingcompany == "") {
				this.errormsgCourier = "Please Select Courier";
				return false;
			} else {
				this.errormsgCourier = '';
				this.input = ({
					awbno: this.awbno,
					clientid: this.client,
					warehouseid: localStorage.getItem("selectedWarehouse"),
					shippingcompany: this.shippingcompany,
					useremail: this.useremail,
				});

				this.isLoading = true;

				axios({
						method: 'POST',
						'url': apiUrl.api_url + 'saveSRInsccan',
						'data': this.input,
						headers: {
							'Authorization': 'Bearer ' + myStr
						}
					})
					.then(result => {
						if (result.data.errorCode == 0) {

							this.isLoading = false;
							this.$alertify.success(result.data.msg);
							this.resetForm();
						} else {
							this.$alertify.error(result.data.msg);
						}

					}, error => {
						console.error(error);
					});

			}
		},

		saveInscanCourierWise() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');


            if (localStorage.getItem("selectedClient") == 'undefined') {
                this.WarehouseErr = this.$t('common.clientError');
                this.$alertify.error(this.$t('common.clientError'))
                return false;
              }
              if (localStorage.getItem("selectedWarehouse") == 'undefined') {
                this.WarehouseErr = this.$t('common.warehouseError');
                this.$alertify.error(this.$t('common.warehouseError'))
                return false;
              }

			if (this.shippingcompany == "") {
				this.errormsgCourier = this.$t('common.courierCompanyError');
				return false;
			}

			if (this.awbno == "") {
				this.errormsg = this.$t('packingb2b.b2bPacking.modal.awbNoError');
				return false;
			}
			else {
				this.errormsg = "";
				this.awbentered = true;
				this.errormsgCourier = '';
				const payload = {
					awbno: this.awbno,
					clientid: this.client,
					warehouseid: localStorage.getItem("selectedWarehouse"),
					shippingcompany: this.shippingcompany,
					useremail: this.useremail,
				};
				this.isLoading = true;

				axios({
						method: 'POST',
						'url': apiUrl.api_url + 'inscan',
						'data': payload,
						headers: {
							'Authorization': 'Bearer ' + myStr
						}
					})
					.then(result => {
						if (result.data.errorCode == 0) {
							this.isLoading = false;
							this.$alertify.success(this.$t(`apiErrors.${result.data.errorLabel}`));
							this.awbno = "";
						} else {
							this.isLoading = false;
							this.$alertify.error(this.$t(`apiErrors.${result.data.errorLabel}`));
							this.awbno = "";
						}

					}, error => {
						this.isLoading = false;
						this.$alertify.error(error.message);
						console.error(error);
					});
			}
		},
		//Reset the Search filter
		resetForm() {

			this.$validator.reset();
			// this.client = '';
			// this.warehouse = '';
			// this.client = '';
			// this.warehouse = '';
			this.awbno = '';
			this.listWarehouseData = [];
			this.shippingcompany = '';
			this.awbentered = false;
			this.listCourierDataRTO = [];
			this.processFlag = '';
			this.shippingid = '';
			this.orderid = '';
			this.shippingData = [];
			this.shippingDataInscan = [];
			this.shippingcompany = '';
			this.errormsgCourier = '';
			this.errormsg = '';
			// this.listCourierWiseData = [];

		},
		async validatevalues() {
			try {
				this.$validator.validateAll().then((result) => {
					if (result) {
						this.Inscan();
					} else {
						console.log("not valid")
					}
				})
			} catch (err) {
				this.isLoading = false;
				this.$alert(err, "", "error");
				console.log(err);
			}
		}
	}
}



// WEBPACK FOOTER //
// ./src/views/components/ReturnInscan/ReturnInscan.component.js